import { useCallback } from 'react'

import { useAudienceAppState } from '../../WebinarAudienceRoom/providers/AudienceAppStateProvider'

import useSimplePubSubMessage from './useSimplePubSubMessage'

export default function useAudiencePublicChannel<T>(
  channel: string,
  onMessage?: (message: T) => void
) {
  const { publicChannelURL } = useAudienceAppState()

  if (publicChannelURL === null) {
    throw new Error(
      'useAudiencePublicChannel must be used after setting publicChannelURL'
    )
  }

  const channelWithSlash = !channel.startsWith('/') ? `/${channel}` : channel
  const channelAppended = `${publicChannelURL}${channelWithSlash}`

  const handleMessage = useCallback(
    (message: string) => {
      onMessage!(JSON.parse(message))
    },
    [onMessage]
  )

  return useSimplePubSubMessage<string>(
    channelAppended,
    onMessage !== undefined ? handleMessage : undefined
  )
}
